The identifier for the `PositionProfile`.
